var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUganda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9057 33.3333C38.0731 29.7949 40 25.1228 40 20C40 14.8772 38.073 10.2051 34.9056 6.66666L20 5.21744L5.09438 6.66666C1.92695 10.2051 0 14.8772 0 20C0 25.1228 1.92688 29.7949 5.0943 33.3333L20 34.7826L34.9057 33.3333Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09436 6.66664H34.9057C31.2436 2.57547 25.9229 0 20 0C14.0771 0 8.75639 2.57547 5.09436 6.66664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20L20 21.7392L40 20C40 17.6622 39.5976 15.4186 38.8603 13.3333H1.13969C0.402422 15.4186 0 17.6622 0 20H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13969 26.6667H38.8605C39.5976 24.5814 40 22.3378 40 20H0C0 22.3378 0.402422 24.5814 1.13969 26.6667V26.6667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9055 33.3333H5.09412C8.75615 37.4246 14.0769 40.0001 19.9998 40.0001C25.9228 40.0001 31.2435 37.4246 34.9055 33.3333Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6739 20C26.6739 23.6862 23.6861 26.6739 20 26.6739C16.3138 26.6739 13.326 23.6862 13.326 20C13.326 16.3138 16.3138 13.3261 20 13.3261C23.6861 13.3261 26.6739 16.3138 26.6739 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4449 20.3404L20 19.2809C20 19.2809 20.572 17.3822 20.6025 17.2523C20.6247 17.1574 20.6366 17.0584 20.6366 16.9567C20.6366 16.5965 20.4906 16.2704 20.2545 16.0344L20.8693 15.4196C20.476 15.0262 19.9325 14.7829 19.3322 14.7829C18.7318 14.7829 18.1883 15.0261 17.795 15.4196L18.4098 16.0344C18.1737 16.2704 18.0278 16.5965 18.0278 16.9567C18.0278 17.0884 18.0477 17.2154 18.084 17.3353L17.1583 18.2609H18.8408C18.8408 18.2609 18.1452 19.3058 17.7654 20.1638C17.3857 21.0218 17.7707 22.0692 18.6483 22.4594L19.1558 22.6849L20 23.4783V24.3479L19.1304 25.2174H20.8696V23.4783L21.6631 22.6847H23.3043C23.3122 22.6684 23.3205 22.6525 23.328 22.6358C23.7179 21.7582 23.3226 20.7304 22.4449 20.3404Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUganda);
export default __webpack_public_path__ + "static/media/uganda.81df2e52ef9a77c29f719c6b0f60b8c0.svg";
export { ForwardRef as ReactComponent };